import type { PaymentCompany, PaymentCompanyListResponse } from '@app/shared/models/polipay-payment.model';
import type { QrMerchantCandidate, QrMerchantCandidatePage } from '@app/domain/models/payments-qr/qr-merchant.model';

/**
 * `PaymentCompany` (el modelo ya mapeado de `GET /companies/`) → candidato del
 * dominio del cobro QR. Normaliza: textos recortados, ausentes a `''`,
 * `org_company_id` vacío a `null`, `is_active` ausente a `null`.
 */
export function toQrMerchantCandidate(company: PaymentCompany): QrMerchantCandidate {
  const org = company.org_company_id;
  return {
    paymentsId: company.id_company,
    name: (company.company_name ?? '').trim(),
    legalName: (company.legal_name ?? '').trim(),
    orgCompanyId: org === null || org === undefined || String(org).trim() === '' ? null : org,
    externalRef: (company.external_ref ?? '').trim(),
    cobraA: company.cobra_a ?? '',
    gatewayAccountId: (company.gateway_account_id ?? '').trim(),
    isActive: typeof company.is_active === 'boolean' ? company.is_active : null,
  };
}

/** Respuesta paginada → página de candidatos; `count` del servidor se conserva. */
export function toQrMerchantCandidatePage(response: PaymentCompanyListResponse): QrMerchantCandidatePage {
  return { count: response.count, results: response.results.map(toQrMerchantCandidate) };
}
